import React from "react";
import { motion } from 'framer-motion';
import { Mail, Phone } from "lucide-react";
import backgroundImage from "../assets/images/background11.jpg";
import ContactForm from "./ContactForm";

const AnyQuestionsSection = () => {
  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.9,
        ease: "easeOut"
      }
    }
  };

  return (
    <section
      className="py-20 bg-cover bg-center relative"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="absolute inset-0 bg-black opacity-70"></div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10">
        <div className="flex flex-wrap -mx-4">
          {/* Left Side - Textual Content */}
          <motion.div
            className="w-full md:w-1/2 px-4 mb-8 md:mb-0"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
          >
            <motion.h2 variants={textVariants} className="text-4xl md:text-5xl font-bold mb-6 text-white">
              Start Your Project
            </motion.h2>
            <motion.p variants={textVariants} className="text-xl text-gray-300 mb-8">
              Tell us about your system and what you need. One of our engineers
              will get back to you within 24 hours.
            </motion.p>
            <motion.ul variants={textVariants} className="space-y-4">
              <li>
                <a
                  href="tel:+17134437247"
                  className="inline-flex items-center text-lg text-white hover:text-gray-300 transition-colors duration-300"
                >
                  <Phone className="w-5 h-5 mr-3" />
                  +1 713-443-7247
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@threephasepowers.com"
                  className="inline-flex items-center text-lg text-white hover:text-gray-300 transition-colors duration-300 [overflow-wrap:anywhere]"
                >
                  <Mail className="w-5 h-5 mr-3 flex-shrink-0" />
                  info@threephasepowers.com
                </a>
              </li>
            </motion.ul>
          </motion.div>

          {/* Right Side - Contact Form */}
          <div className="w-full md:w-1/2 px-4">
            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnyQuestionsSection;
